import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Paper from '@material-ui/core/Paper'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import IconKeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp'
import IconKeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import { withStyles } from '@material-ui/core/styles'


const styles = theme => ({
  root: {
    borderRadius: 3,
    margin: '0 auto',
    backgroundColor: 'white',
    marginTop: theme.spacing(2),
  },
  header: {
    borderRadius: '3px 3px 0 0',
  },
  flexGrow: {
    flexGrow: 1,
  },
  titleWithoutIcon: {
    marginLeft: -40,
  },
  menuButton: {
    marginLeft: -30,
    marginRight: 30,
  },
  content: {
    padding: theme.spacing(1),
  },
})


const Section = ({
  title,
  closed,
  onOpen,
  onClose,
  classes,
  children,
  className,
  disableArrow,
  defaultClosed,
  contentClassName,
  toolbarRightComponent: ToolbarRightComponent,
}) => {
  const [open, setOpen] = useState(!defaultClosed)

  const toggleOpen = () => {
    setOpen(!open)

    if (onOpen && !open) {
      onOpen()
    } else if (onClose && open) {
      onClose()
    }
  }

  const isOpen = closed ? false : open

  return (
    <Paper
      square
      className={classNames(classes.root, className)}
    >
      <AppBar
        position="static"
        className={classes.header}
        color={isOpen ? 'secondary' : 'default'}
      >
        <Toolbar>
          {!disableArrow && (
            <IconButton
              color="inherit"
              aria-label="Menu"
              onClick={toggleOpen}
              className={classes.menuButton}
            >
              {isOpen && <IconKeyboardArrowDown />}
              {!isOpen && <IconKeyboardArrowUp />}
            </IconButton>
          )}

          <Typography
            variant="h3"
            color="inherit"
            className={classNames({
              [classes.titleWithoutIcon]: disableArrow,
            })}
          >
            {title}
          </Typography>

          {ToolbarRightComponent}
        </Toolbar>
      </AppBar>

      <div
        style={{ display: isOpen ? 'block' : 'none' }}
        className={classNames(classes.content, contentClassName)}
      >
        {children}
      </div>
    </Paper>
  )
}


Section.defaultProps = {
  title: '',
  classes: {},
  children: [],
  className: null,
  color: 'primary',
  toolbarRightComponent: null,
}


Section.propTypes = {
  closed: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  color: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  disableArrow: PropTypes.bool,
  defaultClosed: PropTypes.bool,
  contentClassName: PropTypes.string,
  toolbarRightComponent: PropTypes.node,
}


export default withStyles(styles)(Section)
